/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Help.css';
import basicPic from './basic.jpg'
import dataPic from './data.jpg'
import spreadPic from './spread.png'
import participatePic  from './participate.png'
import favorabilityPic from './favorability.png'
import icon from './icon.jpg'
import mindPic from './mind.jpg'

const Qa=[
  {
    name:'基础问题',
    info:'Fundamental Questions',
    img:`${basicPic}`,
    txt:'为您提供数榜的基础操作，术语解释和常见疑难解答'
  },{
    name:'数据问题',
    info:'Data-related Questions',
    img:`${dataPic}`,
    txt:'为您提供数榜的数据来源，结构和细节'
  }
]




const problem=[

  {
    name:'基础问题',
    data:[
      {
        Q:'数字品牌榜的数据来源是什么？',
        A:`我们运用先进的大数据采集、处理和分析技术，每日定向追踪中国主流社交媒体平台微博、微信订阅号、今日头条（头条号和悟空问答）、知乎等平台上的用户评论和文章，数据积累迄今已达10亿条以上，并继续逐日增长。同时，我们的已有数据已包含了自2016年1月1日以来的所有与追踪品牌相关的四个社交媒体平台上的内容。<br>
        所有原始数据和信息均来自于互联网用户的真实表达，我们仅运用云计算和自然语言处理技术，对此进行记录、追踪和计算，而并不干预，由此建立数字品牌榜的数据和计算基础。`
      },{
        Q:'为什么没有我的品牌？',
        A:'在数字品牌榜当前版本中，我们做到了每日追踪500个品牌；我们将继续努力，覆盖更多的品牌。如果您迫切地希望获得您关心的品牌的相关数据，欢迎联系我们，为您提供一对一的定制服务。'
      },{
        Q:'数字品牌榜的数据更新周期是？',
        A:`每日更新。每天中午12点，我们将发布最新的数字品牌榜，反映了截至昨天晚上12点的社交媒体上用户口碑评价的数字品牌价值。<br>
        我们认为，数字品牌DB值是一个累积值，每日的数字品牌榜均呈现了从已获得数据以来到前一日的DB值升跌后的最终结果。因此，周榜、月榜和年榜，并非是在数据计算的窗口期内累加或取平均值的结果，而是截至窗口期结束时的最终数值。`
      },{
        Q:'不同平台的权重是怎么定义的？',
        A:'根据不同社交媒体平台的用户规模、DAU/MAU用户活跃度、平台影响力、企业营销传播的选择优先度等维度和专家指导意见，我们给予不同社交媒体平台以不同的权重。'
      },{
        Q:'怎么添加我的品牌？',
        A:'如果您迫切地希望获得您关心的品牌的相关数据，欢迎联系我们，为您提供一对一的定制服务。'
      },{
        Q:'地理榜是如何划分的？',
        A:`我们依据品牌的原始诞生地或总部所在地，将同一地理区域内的品牌进行DB总值的排序，由此得到数字品牌榜-地理榜。即使该品牌已被跨国或跨地区收购，我们仍将之放入其原始诞生地或总部所在地的品牌池中进行比较。比如SK-II，尽管它已是宝洁旗下品牌，但我们仍将之归入源自日本国的品牌池中进行比较。`
      },{
        Q:'你们的数据报告能否下载？',
        A:`有三种便捷的数据报告下载和获得方式：<br> 
        （1）关于单品牌详情和品牌对比页的图表，可点击右上角的下载按钮（这里放入下载按钮的图标）一键保存。<br>
        （2）使用屏幕截图工具，自由选定和保存相关页面。<br>
        （3）注册成为数字品牌榜的试用体验用户或正式付费用户，您将定期收到详细数据报告，方便您放入您的工作报告中。`
      },{
        Q:'你们的数据是直接拿来计算吗？',
        A:'对于获取到的数据，难以避免存在一些无用信息。因此，我们通过优化算法、增强识别等方式进行了冗余信息过滤、去重等工作。经过优化后的数据，我们仅对此进行记录、追踪和计算，而并不干预，力求还原真实客观的社交媒体环境。'
      }]
  },{
    name:'数据问题',
    data:[
      {
        Q:'什么是心智占有率？',
        A:`心智占有率（Mindshare）的概念，与市场占有率（Marketshare）相对应，用以比喻品牌在消费者头脑中所建立的知名度和美誉度大小。但是，由于缺乏可计算化的方法和数据，这一概念在过去一直停留在“比喻”的层面上，并未成为实际可用的品牌传播测量工具。<br>
        因为有了DB值，品牌的数字价值得以衡量，所以，现在可以计算心智占有率了。<br>
        计算公式为：<br>
        单品牌心智占有率%＝单品牌DB值÷ 所比较全部品牌DB绝对值的总和× 100% <br>
        特别说明：1.由于品牌DB值或正或负，当为负值时，心智占有率也将是负值。它表示了虽然该品牌在受众心智中有知名度，但美誉度却不佳，属于用户在情感上排斥的品牌。2.当所比较的全部品牌中有DB值为负的情况，则取其绝对值进行相加。`,
        img:`${mindPic}`


      },{
        Q:'什么是传播度？',
        A:`某品牌i在某平台上的总传播度计算公式：以累计到当日的传播度总值最高的品牌A作为100%分母，i品牌相对于它的百分比。因此，品牌A每天不一定是同一个品牌。表达公式为：<br/>`,
        img:`${spreadPic}`
      },{
        Q:'什么是参与度？',
        A:`某品牌i在某平台上的总参与度计算公式：以累计到当日的参与度总值最高的品牌A作为100%分母，i品牌相对于它的百分比。因此，品牌A每天不一定是同一个品牌。表达公式为：<br/>`,
        img:`${participatePic}`
      },{
        Q:'什么是好感度？',
        A:`第一层计算：借鉴NPS（净推荐值）的计算方法，以i品牌所有相关文章中好评类与差评类文章的绝对好感值得分之差，除以两者之和，得到i品牌的好感度原始值。<br>
        第二层计算：以累计到当日的好感度原始总值最高的品牌A作为分母100%，i品牌相对于它的百分比。表达公式为：<br/>`,
        img:`${favorabilityPic}`
      },{
        Q:'口碑舆情是如何划分的？',
        A:'数字品牌榜设定了五级好感度指标，并通过机器学习的方式，训练机器越来越聪明地自动识别内容的好感度级别。这五级指标是：推荐 - 好评 - 中立 - 差评 - 反感。 '
      }
    ]
  }
]




class Help extends React.Component {
  constructor(){
    super()
    this.state={
      index:0,
      question:'基础问题',
      lookMore:false
    }
  }
  
  

  render() {

    const {lookMore,index,question}=this.state

    
    return (
      <div className={s.root}>

        <div className={s.box}>
          <div className={s.chapter1} style={{display:!lookMore?'block':'none'}}>
            <div className={s.h2Tit}>
              <b>帮助中心</b>
              <i>Help center</i>
            </div>
            <ul className={s.problemUl}>
              {Qa.map((i)=>
                <li className={s.problem} key={i.name}>
                  <div className={s.top}>
                    <i><img  src={i.img} /></i>
                    <b>{i.name}</b>
                    <p>{i.info}</p>
                  </div>
                  <div className={s.bottom}>{i.txt}</div>
                  <div className={s.more}>
                    <span className={s.moreBtn} onClick={()=>this.setState({index:i.name,question:0,lookMore:true})}>查看详情</span>
                  </div>
                </li>
              )}
            </ul>
          </div>
          <div className={s.chapter2}  style={{display:lookMore?'block':'none'}}>
            <div style={{float:'left'}}>

              {problem.map(i=>
                <p key={i.name} onClick={()=>this.setState({index:i.name,question:0})}  className={s.questionBtn}  style={{color:index==i.name?'#ffd70d':'#7d7d7d'}}>{i.name}</p>
              )}
            </div>
          
            <ul className={s.questionBox}>
              {problem.map(i=>
                  <li key={i.name} className={s.questionLi}>
                    <ol style={{display:this.state.index==i.name?'block':'none'}}  className={s.olList} >
                      {i.data.map((j,key)=>
                        <li key={key}>

                          <p onClick={()=>this.setState({question:key})}  className={s.qqq}>
                            <i style={{display:question==key?'block':'none'}}></i>
                            {j.Q}</p>
                          <p style={{display:this.state.question==key?'block':'none'}} className={s.aaa}>
                            <span dangerouslySetInnerHTML={{__html: j.A}} />
                            {j.img?
                              <i><img  src={j.img}/></i>
                              :null
                            }  
                          </p>
                          
                        </li>
                      )}
                    </ol>
                  </li>
              )}
            </ul>
          </div>
        </div>
        
      </div>
    );
  }
}

export default withStyles(s)(Help);



// WEBPACK FOOTER //
// src/routes/help/Help.js